export default __webpack_public_path__ + "images/EZZ.ce6573d.png";